var React = require('react');

function QuestionIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Artboard","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Group"},[React.createElement("circle",{"id":"Oval","stroke":"#D5E4E6","strokeWidth":"2","cx":"16","cy":"16","r":"15","key":0}),React.createElement("text",{"id":"?","fontFamily":"SourceSansPro-Bold, Source Sans Pro","fontSize":"18","fontWeight":"bold","fill":"#D5E4E6","key":1},React.createElement("tspan",{"x":"11.833","y":"23"},"?"))]))]);
}

QuestionIcon.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = QuestionIcon;

QuestionIcon.default = QuestionIcon;
